import React, { Dispatch, MouseEvent } from 'react';
import '../../App.css';
import HotwashNodeTurn from './HotwashNodeTurn'
import { HotwashNodeLayer } from './HotwashNodeLayer'
import { updateHotwashSelection } from '../../features/hotwash/hotwashSlice'
import { useAppDispatch } from '../../app/hooks'
import { HostSelection } from '../../Classes1';
import { IInjectInfo, IGameStatus, IHotwash } from '../../interfaces';

interface NodeTimelineProps {
    hotwashInjects: IInjectInfo[];
    setInjectItem: Dispatch<any>;
    injectItem: IInjectInfo;
    gameTimeInterval: number;
    showHotwashNodeTimeline: string;
    currentTurn: number;
    currentGame: IGameStatus;
    hotwashStatus: IHotwash;
    updateHotwashStatus: Dispatch<any>;
    isHost: boolean;
    zoomLevel: number;
  }

const HotwashNodeTimeline: React.FC<NodeTimelineProps> = ({ setInjectItem, injectItem, gameTimeInterval, showHotwashNodeTimeline, currentTurn, hotwashInjects, currentGame, hotwashStatus, isHost, updateHotwashStatus, zoomLevel }) => {

    let turnWrapper: string;
    let turnWidth: number = 0;
    if (zoomLevel === 1) {
        turnWidth = 520;
    }
    if (zoomLevel === 2) {
        turnWidth = 325;
    }
    if (zoomLevel === 3) {
        turnWidth = 214;
    }

    turnWrapper = gameTimeInterval * turnWidth + 300 + 'px'

    let numOfTurns: number = 1;
    let hasTurns: number[] = [];
    for (let i = 0; i<injectItem.nodes.length; i++) {
        hasTurns.push(injectItem.nodes[i].turn);
      }
      if (injectItem.nodes.length < 2) {
        numOfTurns = 1;
      } else {
        numOfTurns = Math.max(...hasTurns);
      }

    const dispatch: any = useAppDispatch();
    
    const clickTurn = async (ev: MouseEvent) => {
        ev.stopPropagation();
        const target = ev.currentTarget as HTMLElement;
        if (target) {
            if (isHost) {
                let newHostSelection: any = {};
                newHostSelection.hotwashId = hotwashStatus.gameId;
                newHostSelection.hostSelection = new HostSelection();
                
                newHostSelection.hostSelection.page = '';
                newHostSelection.hostSelection.turn = hotwashStatus.currentSelection.turn;
                newHostSelection.hostSelection.inject = hotwashStatus.currentSelection.inject;
                newHostSelection.hostSelection.node = '';
                newHostSelection.hostSelection.nodeTab = '';
                newHostSelection.hostSelection.nodePlayerID = '';
                newHostSelection.hostSelection.nodeTurn = parseInt(target.dataset.turn!);
                await dispatch(updateHotwashSelection(newHostSelection))
                updateHotwashStatus(hotwashStatus.gameId)
            }
        }
    }

    return (
            <div className={`hotwash-node-content ${showHotwashNodeTimeline}`}>
                <div className="node-turn-wrapper" style={{'width':turnWrapper }}>
                <HotwashNodeLayer injectItem={injectItem} setInjectItem={setInjectItem} hotwashInjects={hotwashInjects} zoomLevel={zoomLevel}  />
                <div className="turn-gutter">
                    <div className="turn-start-scenario">
                        <span>Scenario Start</span>
                    </div>
                </div>

                {Array.from({length: numOfTurns}, (item, index) =>
                    <div key={index} className="hotwash-node-turn-wrapper" onClick={clickTurn} data-turn={index+1}>
                        <HotwashNodeTurn setInjectItem={setInjectItem} injectItem={injectItem} turn={index+1} currentTurn={currentTurn} currentGame={currentGame} hotwashStatus={hotwashStatus} isHost={isHost} updateHotwashStatus={updateHotwashStatus} />
                    </div>
                )}
                </div>
            </div>
    )
}

export default HotwashNodeTimeline;